/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

import type { ContentValue } from '@glint/template';

interface BvActivationFieldSignature {
  Args: {
    active?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    info?: ContentValue;
    inline?: boolean;
    label?: string;
    onClick?: (active: boolean) => void;
  };
  Element: HTMLElement;
}

const BvActivationFieldComponent = templateOnly<BvActivationFieldSignature>('BvActivationField');

export default BvActivationFieldComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvActivationField: typeof BvActivationFieldComponent;
    'bv-activation-field': typeof BvActivationFieldComponent;
  }
}
